module.exports = __webpack_public_path__ + "img/company.c9ddfd31.png";